import { Component, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';

// swagger-ui-dist ships a UMD bundle that is loaded as a global script
// (see angular.json "scripts"), because bundling it through the ESM
// import pipeline does not reliably resolve to the callable function.
declare const SwaggerUIBundle: any;

@Component({
  standalone: false,
  selector: 'api-document',
  templateUrl: './api-document.component.html',
  styleUrls: ['./api-document.component.css']
})
export class ApiDocumentComponent  implements OnInit {
  data: any;
  constructor(
    private http: HttpClient,
    private ngxService: NgxUiLoaderService) { }

  ngOnInit() {
    this.ngxService.start();
    this.UI();
    this.loadJsonData();
    this.ngxService.stop();
  }

  UI() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-landing');
    body.classList.remove('body-login');
    body.classList.remove('mobile-toggle');
  }

  loadJsonData() {
    return this.http.get('/api/app/openAPI')
      .subscribe(data => {
        let jsonData = JSON.stringify(data);
        const homepageurl = environment.HomePageUrl.replace('%3A',':')
        jsonData = jsonData.replace(/ReplaceApiUrl/g, environment.apiSerivceUrl);
        jsonData = jsonData.replace(/ReplaceHomePage/g, homepageurl + 'terms-of-use/api');
        const modifiedData = JSON.parse(jsonData);
        SwaggerUIBundle({
          spec: modifiedData ,
          dom_id: '#swagger',
          layout: 'BaseLayout',
          supportedSubmitMethods: [],
          defaultModelExpandDepth: 10, // 裡面 Schemas
          defaultModelsExpandDepth: 10, // 外面 Schemas Model
          onComplete: function() {
            const buttons = document.getElementsByClassName('model-box-control');
            Array.from(buttons).forEach((btn: HTMLElement) => btn.click());
          }
        });
      });
  } 
}
